import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// actions
import { currentRepCreate } from '../../actions/currentRepActions';

// components
import { StepIndicator } from '../shared/_form';
import New1 from './_New1';
import New2 from './_New2';
import New3 from './_New3';
import { SimplePanel } from '../shared/_panel';

// constants
const TOTAL_STEPS = 3;

// lib
import handleFormChange from '../../lib/handleFormChange';

const steps = [
  New1,
  New2,
  New3
];

class New extends React.Component {
  static propTypes = {
    currentUser: PropTypes.instanceOf(Immutable.Map),
    token:       PropTypes.instanceOf(Immutable.Map)
  }

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map() };
  }

  render() {
    const currentStep = parseInt(this.props.params.currentStep, 10);

    return (
      <div className='body__content body__content--center'>
        <SimplePanel header='Sign Up'>
          { this._renderStep() }
          <StepIndicator currentStep={ currentStep } numSteps={ TOTAL_STEPS } />
        </SimplePanel>
      </div>
    );
  }

  // private

  _handleFormChange = this._handleFormChange.bind(this);
  _handleNextStep   = this._handleNextStep.bind(this);

  _handleFormChange(e) {
    handleFormChange(this)(e);
  }

  _handleNextStep(e) {
    if (e) e.preventDefault();

    const currentStep = parseInt(this.props.params.currentStep, 10);
    const form        = this.state.data.get('form');
    const params      = Object.assign({}, form, { currentStep });

    this.props.dispatch(currentRepCreate(params));
  }

  _renderStep() {
    const currentUser = this.props.currentUser;
    const state       = this.state.data;
    const token       = this.props.token;

    const currentStep = this.props.params.currentStep;
    const stepIndex   = currentStep - 1;
    const form        = state.get('form') || {};

    const errors      = currentUser.get('error') || Immutable.Map();
    const loading     = currentUser.get('loading') || token.get('loading') || false;

    const props = {
      errors:       errors,
      form:         form,
      loading:      loading,
      onFormChange: this._handleFormChange,
      onNextStep:   this._handleNextStep
    };

    return React.createElement(steps[stepIndex], props);
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    token:       state.get('token')
  };
};

export default connect(mapStateToProps)(New);



// WEBPACK FOOTER //
// ./app/components/reps/New.jsx